import React from 'react';
import Formatter from '../../../formatter';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
/** @type {import('../types').DataType<SystemAnalyticsDataModel>} */

var SYSTEM_ANALYTICS_DATA_TYPE = {
  data: {
    url: '/backend/analytics',
    itemUrl: '/backend/analytics?projectName={id}',
    dataKey: 'systemAnalytics',
    idKeyProp: 'Name'
  },
  columns: [{
    id: 'Name',
    children: 'Project',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "project",
        data: data
      });
    }
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    }
  }],
  thumbnail: {
    url: function url(data) {
      return data.PreviewFilePath ? getFileThumbnailPath({
        path: data.PreviewFilePath,
        workspace: data.Workspace,
        token: data.ResourceToken
      }) : null;
    },
    text: function text(data) {
      return data.Name;
    },
    icon: function icon(data) {
      return data.Type;
    }
  },
  placeholders: {
    label: function label(data) {
      return data ? data.Name : '';
    },
    type: 'project',
    icon: 'analyticsdashboard'
  },
  contextMenu: [{
    type: 'delete'
  }]
};
export default SYSTEM_ANALYTICS_DATA_TYPE;